<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="verificarIntegracaoModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content" v-if="marcacao">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            Integração
                            #{{ marcacao.id_atendimento }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="dados && dados.atendimento && dados.atendimento.atendimento_procedimentos">

                            <div class="alert alert-info">
                                <div>{{ dados.nome_paciente }}</div>
                                <div>
                                    {{ $util.getFormatDate(dados.dt_inicio) }}
                                    <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                                    {{ dados.st_id_externo }}
                                </div>
                                <div>Total Klingo: {{ $util.formatMoeda(total_klingo) }}</div>
                                <div>
                                    Total Integrado: {{ $util.formatMoeda(total_integrado) }}
                                    <span class="text-success" v-if="valor_batido">
                                        <i class="fa fa-check-circle" aria-hidden="true"></i>
                                    </span>
                                    <span class="text-danger" v-else>
                                        <i class="fa fa-times-circle" aria-hidden="true"></i>
                                    </span>
                                </div>
                            </div>

                            <div v-if="retorno && retorno.status && retorno.status == 'ERRO'" class="alert alert-warning">
                                <span v-if="retorno.mensagem">
                                    {{ retorno.mensagem }}
                                </span>
                                <span v-else>
                                    Falha na verificação.
                                </span>
                            </div>

                            <div v-if="info_pag && info_pag.texto" class="alert alert-secondary" style="white-space: pre-wrap;">{{ info_pag.texto }}</div>

                            <az-input
                                sizing="sm"
                                class="mb-3"
                                type="checkbox-group"
                                v-if="tem_candidatos"
                                label="Filtrar itens para cancelamento."
                                v-model="filtrar_candidatos" />

                            <table class="table">
                                <thead>
                                    <tr>
                                        <th width="5%">
                                            <button type="button" class="btn btn-outline-primary btn-sm" v-if="lista_candidatos.length" @click="selecionar_todos()">
                                                Todos
                                            </button>
                                        </th>
                                        <th>Procedimento</th>
                                        <th>Status Integrado</th>
                                        <th class="text-right">Valor</th>
                                        <th class="text-right">Integrado</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(atp, iax) in dados.atendimento.atendimento_procedimentos">
                                        <tr :key="iax" v-show="!filtrar_candidatos || ( atp.fl_ativo && atp.smm && atp.smm.smm_exec == 'C')"
                                            :class="cor_atencao(atp)"> 
                                            <td>
                                                <az-input
                                                    v-if="( atp.fl_ativo && atp.smm && atp.smm.smm_exec == 'C')"
                                                    type="checkbox"
                                                    v-model="atp.excluido" />
                                            </td>
                                            <td>
                                                <span class="badge badge-secondary mr-2" v-if="atp.procedimento.st_sigla">
                                                    {{ atp.procedimento.st_sigla }}
                                                </span>
                                                {{ atp.procedimento.search }}
                                                <span class="badge badge-warning" v-if="!atp.fl_ativo && !atp.id_atendimento_procedimento">
                                                    Não Encontrado
                                                </span>
                                                <span class="badge badge-danger" v-else-if="!atp.fl_ativo">
                                                    Cancelado
                                                </span>
                                                <div class="small text-muted" v-if="atp.amostra">
                                                    {{ atp.amostra.st_amostra_material }}
                                                </div>
                                            </td>
                                            <td>
                                                <span v-if="atp.smm">
                                                    {{ atp.smm.smm_exec }}
                                                    <span class="badge mx-2" :style="atp.smm.status.style" v-if="atp.smm.status" title="Status de Execução">
                                                        {{ atp.smm.status.texto }}
                                                    </span>
                                                    <span>
                                                        {{ atp.smm.smm_num }}
                                                    </span>
                                                </span>
                                            </td>
                                            <td class="text-right">
                                                {{ $util.formatMoeda(atp.cd_valor_total) }}
                                            </td>
                                            <td class="text-right">
                                                <div v-if="atp.smm">
                                                    <span class="badge" :class="'badge-' + ( atp.smm.smm_vlr == atp.cd_valor_total ? 'success' : 'danger' )" title="Status de Faturamento">
                                                        {{ atp.smm.smm_sfat }}
                                                    </span>
                                                    {{ $util.formatMoeda(atp.smm.smm_vlr) }}
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>

                        </template>

                        <az-empty-state v-else />

                        <pre v-if="false">{{ dados }}</pre>
                        <pre v-if="false">{{ retorno }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit color="danger" v-if="lista_para_cancelar.length" @click="cancelar_items()">
                            Cancelar Exames 
                            <span class="badge badge-light ml-2">
                                {{ lista_para_cancelar.length }}
                            </span>
                        </az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data () { 
        return { 
            marcacao: null, 
            dados: null, 
            retorno: null, 
            info_pag: null, 
            filtrar_candidatos: false, 
            total_klingo: 0,
            total_integrado: 0,
            valor_batido: false, 
        };
    },

    components: { 
        AzEmptyState, 
        AzInput,
        AzSubmit,  
    },

    computed: { 
        lista_candidatos: function () { 
            if ( !this.dados || !this.dados.atendimento || !this.dados.atendimento.atendimento_procedimentos )
                return [];

            return this.dados.atendimento.atendimento_procedimentos.filter(item => item.fl_ativo && item.smm && item.smm.smm_exec == 'C');
        },

        lista_para_cancelar: function () { 
            if ( !this.dados || !this.dados.atendimento || !this.dados.atendimento.atendimento_procedimentos )
                return [];

            return this.dados.atendimento.atendimento_procedimentos.filter(item => item.excluido);
        },

        tem_candidatos: function () { 
            return this.lista_candidatos.length && this.lista_candidatos.length < this.dados.atendimento.atendimento_procedimentos.length;
        },
    },

    methods: { 
        cor_atencao (atp) { 
            if ( atp.id_atendimento_procedimento && atp.fl_ativo && atp.cd_valor_total > 0 && ( !atp.smm || atp.smm.smm_exec == 'C' ) ) { 
                return 'table-danger';
            } 

            if ( atp.smm && atp.smm.smm_exec != 'C' && atp.smm.smm_vlr > 0 && !atp.id_atendimento_procedimento ) { 
                return 'table-danger';
            }

            if ( atp.smm 
                && atp.smm.smm_exec != 'C' 
                && atp.id_atendimento_procedimento 
                && atp.fl_ativo 
                && Math.round(atp.cd_valor_total * 100) != Math.round(atp.smm.smm_vlr * 100) ) { 
                return 'table-warning';
            }

            return '';
        },

        selecionar_todos () { 
            const selec = this.lista_candidatos.find(item => item.excluido) ? false : true;

            this.lista_candidatos.forEach(item => {
                item.excluido = selec;
            });
        },

        abrir (marcacao) { 

            this.marcacao = _.cloneDeep(marcacao);
            this.dados = null;
            this.retorno = null;
            this.info_pag = null; 
            this.filtrar_candidatos = false;

            $('#verificarIntegracaoModal').modal('show');

            this.$util.load(this, {
                service: 'atendimentos',
                func: 'integracao',
                redir_api: true, 
                parms: {
                    id_marcacao: marcacao.id_marcacao,
                },
                loadTo: res => { 
                    /* Para Testes...
                    res.marcacao.atendimento.atendimento_procedimentos.forEach(item => { 
                        item.smm.smm_exec = 'C';
                    });
                    */

                    this.dados = res.marcacao;
                    this.retorno = res.retorno;
                    this.total_klingo = res.total_klingo;
                    this.total_integrado = res.total_integrado;
                    this.valor_batido = res.valor_ok;
                    this.info_pag = res.info_pag;
                }
            });

        },

        cancelar_items () { 
            if ( !confirm('Confirma cancelar os itens selecionados?') )
                return;

            this.$util.atualizar(this, { 
                service: 'atendimentos',
                func: 'cancelar_atend_procs',
                dados: { 
                    id_atendimento: this.dados.id_atendimento,
                    lista: this.lista_para_cancelar.map(item => item.id_atendimento_procedimento),
                },
                modal: 'verificarIntegracaoModal',
                toast: true,
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        }
    }
}
</script>